import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Dialog } from 'primereact/dialog';

import ButtonSp from '../../components/ButtonSp';
import InputTextSp from '../../components/InputTextSp';
import LabelSp from '../../components/LabelSp';
import { ACOES } from './util';

// Confirma uma acao no AFV. Limpar e remover so liberam com o contrato digitado (a API e o
// servidor conferem de novo).
function DialogoAcao(props) {
  DialogoAcao.propTypes = {
    acao: PropTypes.string.isRequired,
    numeroContrato: PropTypes.number.isRequired,
    nomeCliente: PropTypes.string,
    onConfirm: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  const { acao, numeroContrato, nomeCliente, onConfirm, onClose } = props;
  const info = ACOES[acao];
  const [digitado, setDigitado] = useState('');
  const valido = !info.destrutiva || digitado === String(numeroContrato);

  const footer = (
    <div>
      <ButtonSp
        className={info.destrutiva ? 'p-button-danger' : 'p-button-success'}
        icon="pi pi-check"
        label="Confirmar"
        disabled={!valido}
        onClick={() => onConfirm(digitado)}
      />
      <ButtonSp
        className="p-button-secondary"
        icon="pi pi-times"
        label="Cancelar"
        onClick={onClose}
      />
    </div>
  );

  return (
    <Dialog
      closable={false}
      footer={footer}
      header={`${info.titulo} - contrato ${numeroContrato}`}
      visible
      modal
      style={{ minWidth: '320px', maxWidth: '560px', width: '95%' }}
      onHide={onClose}
    >
      <div className="p-grid p-fluid">
        {nomeCliente ? (
          <div className="p-col-12">
            <strong>{nomeCliente}</strong>
          </div>
        ) : null}
        <div className="p-col-12" style={info.destrutiva ? { color: '#dc3545' } : {}}>
          {info.texto}
        </div>
        {info.destrutiva ? (
          <div className="p-col-12 p-sm-6">
            <LabelSp>Digite o número do contrato para confirmar</LabelSp>
            <InputTextSp
              autoFocus
              value={digitado}
              onChange={e => setDigitado(e.target.value.replace(/\D/g, ''))}
            />
          </div>
        ) : null}
      </div>
    </Dialog>
  );
}

export default DialogoAcao;
